import { render, staticRenderFns } from "./WaybillNodeMonitorTable.vue?vue&type=template&id=22005ed4&scoped=true&"
import script from "./WaybillNodeMonitorTable.vue?vue&type=script&lang=js&"
export * from "./WaybillNodeMonitorTable.vue?vue&type=script&lang=js&"
import style0 from "./WaybillNodeMonitorTable.vue?vue&type=style&index=0&id=22005ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22005ed4",
  null
  
)

export default component.exports